import React, {useContext} from 'react'
import { Row, Col  } from "antd";
import { ContainerOutlined, AuditOutlined, ApartmentOutlined } from '@ant-design/icons';
import { AppContext } from '../../util/context';

export const HomeMenu = ({current, setCurrent}) => {
    const {
        StyledDiv
    } = useContext(AppContext);
    return (
        <>
            <Row className="homeMenuRow">
                <Col span={24} className="homeMenuCol">
                    <div
                        className="homeMenuContainer"
                        onClick={() => {
                            setCurrent("mycards")
                        }}
                    >
                        <ContainerOutlined className={current === "mycards" ? "homeMenuIconSelected" : "homeMenuIcon"} />
                        <StyledDiv
                            className={current === "mycards" ? "homeMenuTextSelected" : "homeMenuText"}
                        >
                            <span className="homeMenuLabelFull">CARDS</span>
                            <span className="homeMenuLabelShort">CARDS</span>
                        </StyledDiv>
                    </div>

                    <div
                        className="homeMenuContainer"
                        onClick={() => {
                            setCurrent("myteamscards")
                        }}
                    >
                        <AuditOutlined className={current === "myteamscards" ? "homeMenuIconSelected" : "homeMenuIcon"} />
                        <StyledDiv
                            className={current === "myteamscards" ? "homeMenuTextSelected" : "homeMenuText"}
                        >
                            <span className="homeMenuLabelFull">MY TEAM'S CARDS</span>
                            <span className="homeMenuLabelShort">TEAM</span>
                        </StyledDiv>
                    </div>


                    <div
                        className="homeMenuContainer"
                        onClick={() => {
                            setCurrent("assignedactionstoteam")
                        }}
                    >
                        <ApartmentOutlined className={current === "assignedactionstoteam" ? "homeMenuIconSelected" : "homeMenuIcon"} />
                        <StyledDiv
                            className={current === "assignedactionstoteam" ? "homeMenuTextSelected" : "homeMenuText"}
                        >
                            <span className="homeMenuLabelFull">ACTIONS ASSIGNED TO MY TEAM</span>
                            <span className="homeMenuLabelShort">ACTIONS</span>
                        </StyledDiv>
                    </div>



                </Col>
            </Row>
        </>
    )
}
